import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { watchPageVisibility } from '@/game/audio/pageVisibility';
import { registerServiceWorker } from '@/pwa/install';
import { App } from './app/App';
import './styles/index.css';

const host = document.getElementById('root');
if (!host) throw new Error('#root missing from index.html');

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/* Offline shell + installability. No-ops in dev. */
registerServiceWorker();

/* Silence the cave while the app is in the background or behind a rewarded video. */
watchPageVisibility();
